import React from 'react'
import PageHeader from "../components/PageHeader";

// import "../css/dajiMah.css";
import "../css/goshala.css";
import { goshalaImg } from '../assets/assets.js';

const Goshala = () => {
    return (
        <>  
            <PageHeader title="गोशाळा " path="/about-goshala" name=" goshala" />
            {/* <Initiatives /> */}
       
<div className='goshala-main-container'>
<div className="goshala-container">
        <h2 className="goshala-title">संतवर्य योगिराज गंगाजीबापूमहाराज गोसेवा प्रकल्प</h2>
        <p className="goshala-description">
        {/* description removed */}
        श्रीसद्गुरु वेंकटेश दाजीमहाराजांचे योगसिद्धी गुरू संतवर्य श्रीगंगाजीबापूमहाराज यांच्या गो सेवेच्या व्रताला पुढे चालवण्याच्या हेतूने संस्थान अधिपती वेदमूर्ती श्रीउमेश महाराज टाकळीकर यांनी संतवर्य श्रीगंगाजीबापूमहाराज गोसेवा प्रकल्पाची स्थापना केली.
          <br /> 
          <img src={goshalaImg.g_img_1} alt="Happy Cows at the Goshala" className="goshala-image" /> 
        </p>

        <div className="goshala-section">
          
          <p>
        या गोसेवा प्रकल्पात सर्व उच्च प्रतीच्या देशी गाईंचा व वासरांचा समावेश आहे . येथे विविध प्रकारच्या देशी गाईंचे वंश निर्भेळपणेपुढे वाढविण्यासाठी विशेष प्रयत्न केले जातात. गाईंपासून मिळणारे दूध  व त्यांपासून निर्माण होणारे दही तूप इत्यादीपूर्णपणे सर्व गुरुकुलातील विद्यार्थ्यांसाठी तसेच यज्ञ याग अधिक इत्यादींसाठी  गुरुकुलातील विद्यार्थ्यांसाठी व संस्थांमध्ये सेवेसाठी वापरल्या जाते.
          </p>
        </div>

       
      </div>

</div>
        </>
    );
}
export default Goshala